import React, { forwardRef, useState } from "react";
import { FaRetweet } from "react-icons/fa";
import { Button, Tooltip } from "@mui/material";

const SwapButton = forwardRef(({ onSwapLayout }, ref) => {
  // const [isCycleLayoutOn, setIsCycleLayoutOn] = useState(false);

  const hoverBtnDescription = (
    <p style={{ fontSize: "1rem", margin: 0 }}>Swap Layout</p>
  );

  const swapLayout = (event) => {
    event.preventDefault();
    onSwapLayout(event);
  };

  return (
    <div>
      <Tooltip
        title={hoverBtnDescription}
        disableinteractive="true"
        slotprops={{
          tooltip: {
            sx: {
              bgcolor: "#545859",
            },
          },
        }}
      >
        <Button
          variant="contained"
          className="context-menu-btns"
          sx={{
            backgroundColor: "#ffffff",
            border: "1px solid #00449e",
            borderColor: "#00449e",
            cursor: "pointer",
            borderRadius: "0.5rem",
            color: "#00449e",
                "&:hover": {
                  backgroundColor: "#eaf1fb",
                },
                "&:focus:not(:hover)": {
                  backgroundColor: "#ffffff",
                  boxShadow: "none",
                },
          }}
          onClick={(event) => swapLayout(event)}
          ref={ref}
        >
          <FaRetweet size="1rem" color="#00449e" />
        </Button>
      </Tooltip>
    </div>
  );
});

export default SwapButton;
